import illustrationUrls from './illustrationUrls'; // @ts-expect-error bender-url not typed

import landingPageHeadshot1x from 'bender-url!../../images/landing-page-headshot/landing-page-headshot@1x.png'; // @ts-expect-error bender-url not typed

import landingPageHeadshot2x from 'bender-url!../../images/landing-page-headshot/landing-page-headshot@2x.png'; // @ts-expect-error bender-url not typed

import landingPageHeadshot3x from 'bender-url!../../images/landing-page-headshot/landing-page-headshot@3x.png'; // @ts-expect-error bender-url not typed

import redLaughingGlasses1x from 'bender-url!../../images/red-laughing-glasses/red-laughing-glasses@1x.png'; // @ts-expect-error bender-url not typed

import redLaughingGlasses2x from 'bender-url!../../images/red-laughing-glasses/red-laughing-glasses@2x.png'; // @ts-expect-error bender-url not typed

import redLaughingGlasses3x from 'bender-url!../../images/red-laughing-glasses/red-laughing-glasses@3x.png'; // @ts-expect-error bender-url not typed

import girlSmillingPinkJacket1x from 'bender-url!../../images/girl-smiling-pink-jacket/girl-smiling-pink-jacket@1x.png'; // @ts-expect-error bender-url not typed

import girlSmillingPinkJacket2x from 'bender-url!../../images/girl-smiling-pink-jacket/girl-smiling-pink-jacket@2x.png'; // @ts-expect-error bender-url not typed

import girlSmillingPinkJacket3x from 'bender-url!../../images/girl-smiling-pink-jacket/girl-smiling-pink-jacket@3x.png'; // @ts-expect-error bender-url not typed

import shortBlackHairSmiling1x from 'bender-url!../../images/short-black-hair-smiling/short-black-hair-smiling@1x.png'; // @ts-expect-error bender-url not typed

import shortBlackHairSmiling2x from 'bender-url!../../images/short-black-hair-smiling/short-black-hair-smiling@2x.png'; // @ts-expect-error bender-url not typed

import shortBlackHairSmiling3x from 'bender-url!../../images/short-black-hair-smiling/short-black-hair-smiling@3x.png'; // @ts-expect-error bender-url not typed

import glassesColourfulScarf1x from 'bender-url!../../images/glasses-colourful-scarf/glasses-colourful-scarf@1x.png'; // @ts-expect-error bender-url not typed

import glassesColourfulScarf2x from 'bender-url!../../images/glasses-colourful-scarf/glasses-colourful-scarf@2x.png'; // @ts-expect-error bender-url not typed

import glassesColourfulScarf3x from 'bender-url!../../images/glasses-colourful-scarf/glasses-colourful-scarf@3x.png'; // @ts-expect-error bender-url not typed

import blueGreyBeardGlasses1x from 'bender-url!../../images/blue-grey-beard-glasses/blue-grey-beard-glasses@1x.png'; // @ts-expect-error bender-url not typed

import blueGreyBeardGlasses2x from 'bender-url!../../images/blue-grey-beard-glasses/blue-grey-beard-glasses@2x.png'; // @ts-expect-error bender-url not typed

import blueGreyBeardGlasses3x from 'bender-url!../../images/blue-grey-beard-glasses/blue-grey-beard-glasses@3x.png'; // @ts-expect-error bender-url not typed

import rever1x from 'bender-url!../../images/rever/logo-r-red@1x.png'; // @ts-expect-error bender-url not typed

import rever2x from 'bender-url!../../images/rever/logo-r-red@2x.png'; // @ts-expect-error bender-url not typed

import rever3x from 'bender-url!../../images/rever/logo-r-red@3x.png'; // @ts-expect-error bender-url not typed

import recaptchaVerification from 'bender-url!../../images/recaptcha-verification.svg'; // @ts-expect-error bender-url not typed

import connectLogo from 'bender-url!../../images/connect.com-full-logo-color.png'; // @ts-expect-error bender-url not typed

import connectMobileLogo from 'bender-url!../../images/connect.com-infinity-icon-color.png'; // @ts-expect-error bender-url not typed

import hubSpotForStartupsLogo from 'bender-url!../../images/hubspot-for-startups.svg'; // @ts-expect-error bender-url not typed

import anneHubspot1x from 'bender-url!../../images/anne-hubspot/anne-hubspot@1x.svg'; // @ts-expect-error bender-url not typed

import anneHubspot2x from 'bender-url!../../images/anne-hubspot/anne-hubspot@2x.svg'; // @ts-expect-error bender-url not typed

import anneHubspot3x from 'bender-url!../../images/anne-hubspot/anne-hubspot@3x.svg'; // @ts-expect-error bender-url not typed

import classpassLogo from 'bender-url!../../images/logos/classpass-logo.png'; // @ts-expect-error bender-url not typed

import g2CrowdLogo from 'bender-url!../../images/logos/g2-crowd-logo.png'; // @ts-expect-error bender-url not typed

import soundcloudLogo from 'bender-url!../../images/logos/soundcloud.png'; // @ts-expect-error bender-url not typed

import longSurveyMonkeyLogo from 'bender-url!../../images/logos/long-surveymonkey.png'; // @ts-expect-error bender-url not typed

import trelloLogo from 'bender-url!../../images/logos/trello.png'; // @ts-expect-error bender-url not typed

import vmwareLogo from 'bender-url!../../images/logos/vmware-png-logo.png'; // @ts-expect-error bender-url not typed

import wwfLogo from 'bender-url!../../images/logos/WWF-logo.png'; // @ts-expect-error bender-url not typed

import loomLogo from 'bender-url!../../images/logos/loom-logo.png'; // @ts-expect-error bender-url not typed

import frontifyLogo from 'bender-url!../../images/logos/frontify-logo.png'; // @ts-expect-error bender-url not typed

import mondayLogo from 'bender-url!../../images/logos/monday-logo.png'; // @ts-expect-error bender-url not typed

import legalZoomLogo from 'bender-url!../../images/logos/legalzoom.png'; // @ts-expect-error bender-url not typed

import vacasaLogo from 'bender-url!../../images/logos/vacasa.png'; // @ts-expect-error bender-url not typed

import motleyFoolLogo from 'bender-url!../../images/logos/The-Motley-Fool.png'; // @ts-expect-error bender-url not typed

import casioLogo from 'bender-url!../../images/logos/casio.png'; // @ts-expect-error bender-url not typed

import wistiaLogo from 'bender-url!../../images/logos/wistia.png'; // @ts-expect-error bender-url not typed

import zapierLogo from 'bender-url!../../images/logos/zapier-logo.png'; // @ts-expect-error bender-url not typed

import irwinLogo from 'bender-url!../../images/logos/irwin-logo.jpeg'; // @ts-expect-error bender-url not typed

import goFundMeLogo from 'bender-url!../../images/logos/gofundme-logo.png'; // @ts-expect-error bender-url not typed

import newcastleUniversityLogo from 'bender-url!../../images/logos/newcastleuniversity-logo.png'; // @ts-expect-error bender-url not typed

import oceanSprayLogo from 'bender-url!../../images/logos/oceanspray-logo.png'; // @ts-expect-error bender-url not typed

import ezCaterLogo from 'bender-url!../../images/logos/ezcater-logo.png'; // @ts-expect-error bender-url not typed

import katapultLogo from 'bender-url!../../images/logos/katapult-logo.png'; // @ts-expect-error bender-url not typed

import gonzaloTorrerasLogo from 'bender-url!../../images/logos/gonzalo-torreras-logo.svg'; // @ts-expect-error bender-url not typed

import flywheelEnglish from 'bender-url!../../images/flywheel/flywheel-en.png'; // @ts-expect-error bender-url not typed

import flywheelFrench from 'bender-url!../../images/flywheel/flywheel-fr.png'; // @ts-expect-error bender-url not typed

import flywheelSpanish from 'bender-url!../../images/flywheel/flywheel-es.png'; // @ts-expect-error bender-url not typed

import flywheelGerman from 'bender-url!../../images/flywheel/flywheel-de.png'; // @ts-expect-error bender-url not typed

import flywheelPortuguese from 'bender-url!../../images/flywheel/flywheel-pt-br.png'; // @ts-expect-error bender-url not typed

import personWithBox1x from 'bender-url!../../images/person-with-box/person-with-box@1x.svg'; // @ts-expect-error bender-url not typed

import personWithBox2x from 'bender-url!../../images/person-with-box/person-with-box@2x.svg'; // @ts-expect-error bender-url not typed

import personWithBox3x from 'bender-url!../../images/person-with-box/person-with-box@3x.svg'; // @ts-expect-error bender-url not typed

import longBrownHairRed1x from 'bender-url!../../images/long-brown-hair-red/long-brown-hair-red@1x.png'; // @ts-expect-error bender-url not typed

import longBrownHairRed2x from 'bender-url!../../images/long-brown-hair-red/long-brown-hair-red@2x.png'; // @ts-expect-error bender-url not typed

import longBrownHairRed3x from 'bender-url!../../images/long-brown-hair-red/long-brown-hair-red@3x.png'; // @ts-expect-error bender-url not typed

import hands1x from 'bender-url!../../images/hands/hands@1x.svg'; // @ts-expect-error bender-url not typed

import hands2x from 'bender-url!../../images/hands/hands@2x.svg'; // @ts-expect-error bender-url not typed

import hands3x from 'bender-url!../../images/hands/hands@3x.svg'; // @ts-expect-error bender-url not typed

import whiteHouse1x from 'bender-url!../../images/white-house/white-house@1x.svg'; // @ts-expect-error bender-url not typed

import whiteHouse2x from 'bender-url!../../images/white-house/white-house@2x.svg'; // @ts-expect-error bender-url not typed

import whiteHouse3x from 'bender-url!../../images/white-house/white-house@3x.svg'; // @ts-expect-error bender-url not typed

import crmCentralPlace1x from 'bender-url!../../images/crm-central-place/crm-central-place@1x.svg'; // @ts-expect-error bender-url not typed

import crmCentralPlace2x from 'bender-url!../../images/crm-central-place/crm-central-place@2x.svg'; // @ts-expect-error bender-url not typed

import crmCentralPlace3x from 'bender-url!../../images/crm-central-place/crm-central-place@3x.svg'; // @ts-expect-error bender-url not typed

import blondeShelley1x from 'bender-url!../../images/blonde-shelley/blonde-shelley@1x.png'; // @ts-expect-error bender-url not typed

import blondeShelley2x from 'bender-url!../../images/blonde-shelley/blonde-shelley@2x.png'; // @ts-expect-error bender-url not typed

import blondeShelley3x from 'bender-url!../../images/blonde-shelley/blonde-shelley@3x.png'; // @ts-expect-error bender-url not typed

import adriti1x from 'bender-url!../../images/academy/adriti@1x.svg'; // @ts-expect-error bender-url not typed

import adriti2x from 'bender-url!../../images/academy/adriti@2x.svg'; // @ts-expect-error bender-url not typed

import adriti3x from 'bender-url!../../images/academy/adriti@3x.svg'; // @ts-expect-error bender-url not typed

import kyle1x from 'bender-url!../../images/academy/kyle@1x.svg'; // @ts-expect-error bender-url not typed

import kyle2x from 'bender-url!../../images/academy/kyle@2x.svg'; // @ts-expect-error bender-url not typed

import kyle3x from 'bender-url!../../images/academy/kyle@3x.svg'; // @ts-expect-error bender-url not typed

import kara1x from 'bender-url!../../images/academy/kara@1x.svg'; // @ts-expect-error bender-url not typed

import kara2x from 'bender-url!../../images/academy/kara@2x.svg'; // @ts-expect-error bender-url not typed

import kara3x from 'bender-url!../../images/academy/kara@3x.svg'; // @ts-expect-error bender-url not typed

import wordpressAuthorizationConnect from 'bender-url!../../images/wordpress-authorization-connect.svg'; // @ts-expect-error bender-url not typed

import lockScreenAnimation from 'bender-url!../../images/animated-images/lock_center.webm'; // @ts-expect-error bender-url not typed

import emailAnimation from 'bender-url!../../images/animated-images/email_open.webm'; // @ts-expect-error bender-url not typed

import salesMeetingsCalendar from 'bender-url!../../images/sales-meetings-calendar/sales-meetings-calendar.png'; // @ts-expect-error bender-url not typed

import salesLeaderCalendar from 'bender-url!../../images/sales-leader-calendar/sales-leader-calendar.png'; // @ts-expect-error bender-url not typed

import salesMeetingsConfirmation from 'bender-url!../../images/sales-meetings-confirmation/sales-meetings-confirmation.png'; // @ts-expect-error bender-url not typed

import timeslotCalendar from 'bender-url!../../images/timeslot-calendar/timeslot-calendar.png'; // @ts-expect-error bender-url not typed

import academyLogo from 'bender-url!../../images/academy/hubspot-academy-logo.svg'; // @ts-expect-error bender-url not typed

import linkedInLogo from 'bender-url!../../images/logos/linkedin.png'; // @ts-expect-error bender-url not typed

import microsoftLogo from 'bender-url!../../images/logos/microsoft.png'; // @ts-expect-error bender-url not typed

import facebookLogo from 'bender-url!../../images/logos/facebook.png'; // @ts-expect-error bender-url not typed

import appleLogo from 'bender-url!../../images/logos/apple.png'; // @ts-expect-error bend-url not typed

import cmsFreeAnimation from 'bender-url!../../images/animated-images/cmsfree-dnd-editor.webm'; // @ts-expect-error bend-url not typed

import cmsFreeMarketplace1x from 'bender-url!../../images/cmsfree-marketplace/cmsfree-marketplace@1x.png'; // @ts-expect-error bend-url not typed

import cmsFreeMarketplace2x from 'bender-url!../../images/cmsfree-marketplace/cmsfree-marketplace@2x.png'; // @ts-expect-error bend-url not typed

import cmsFreeMarketplace3x from 'bender-url!../../images/cmsfree-marketplace/cmsfree-marketplace@3x.png'; // @ts-expect-error bend-url not typed

import hubspotIntegrations from 'bender-url!../../images/hubspot-integrations/integrations.png'; // @ts-expect-error bend-url not typed

import hubspotIntegrationsAnimation from 'bender-url!../../images/animated-images/hubspot_integrations.webm'; // @ts-expect-error bend-url not typed

import salesExtensionInstall from 'bender-url!../../images/email-tracking-flow/sales-extension-install.png'; // @ts-expect-error bend-url not typed

import checkSign from 'bender-url!../../images/email-tracking-flow/check-sign.png'; // @ts-expect-error bend-url not typed

import emailTracking from 'bender-url!../../images/email-tracking-flow/email-tracking.png'; // @ts-expect-error bend-url not typed

import emailConfirmation from 'bender-url!../../images/email-tracking-flow/email-confirmation.png'; // @ts-expect-error bend-url not typed

import salesExtensionReview from 'bender-url!../../images/email-tracking-flow/sales-extension-review.png'; // @ts-expect-error bender-url not typed

import chatSpotLogo from 'bender-url!../../images/chatspot.png'; // @ts-expect-error bender-url not typed

import chatSpotMobileLogo from 'bender-url!../../images/chatspot-mobile.png'; // @ts-expect-error bender-url not typed

import welcomeImage from 'bender-url!../../images/welcome.svg'; // @ts-expect-error bender-url not typed

import appleLogoWhite from 'bender-url!../../images/logos/apple_white.png'; // @ts-expect-error bender-url not typed

import linkedinLogoWhite from 'bender-url!../../images/logos/linkedin_white.png'; // @ts-expect-error bender-url not typed

import paypalLogo from 'bender-url!../../images/logos/paypal.png'; // @ts-expect-error bender-url not typed

import wordpressLogo from 'bender-url!../../images/logos/wordpress.png';
export default Object.assign({
  landingPageHeadshot1x,
  landingPageHeadshot2x,
  landingPageHeadshot3x,
  redLaughingGlasses1x,
  redLaughingGlasses2x,
  redLaughingGlasses3x,
  girlSmillingPinkJacket1x,
  girlSmillingPinkJacket2x,
  girlSmillingPinkJacket3x,
  shortBlackHairSmiling1x,
  shortBlackHairSmiling2x,
  shortBlackHairSmiling3x,
  glassesColourfulScarf1x,
  glassesColourfulScarf2x,
  glassesColourfulScarf3x,
  blueGreyBeardGlasses1x,
  blueGreyBeardGlasses2x,
  blueGreyBeardGlasses3x,
  rever1x,
  rever2x,
  rever3x,
  personWithBox1x,
  personWithBox2x,
  personWithBox3x,
  hands1x,
  hands2x,
  hands3x,
  whiteHouse1x,
  whiteHouse2x,
  whiteHouse3x,
  anneHubspot1x,
  anneHubspot2x,
  anneHubspot3x,
  longBrownHairRed1x,
  longBrownHairRed2x,
  longBrownHairRed3x,
  crmCentralPlace1x,
  crmCentralPlace2x,
  crmCentralPlace3x,
  blondeShelley1x,
  blondeShelley2x,
  blondeShelley3x,
  classpassLogo,
  g2CrowdLogo,
  soundcloudLogo,
  longSurveyMonkeyLogo,
  trelloLogo,
  vmwareLogo,
  wwfLogo,
  flywheelEnglish,
  flywheelFrench,
  flywheelSpanish,
  flywheelPortuguese,
  flywheelGerman,
  loomLogo,
  frontifyLogo,
  mondayLogo,
  recaptchaVerification,
  legalZoomLogo,
  vacasaLogo,
  motleyFoolLogo,
  casioLogo,
  wistiaLogo,
  zapierLogo,
  irwinLogo,
  goFundMeLogo,
  newcastleUniversityLogo,
  oceanSprayLogo,
  ezCaterLogo,
  katapultLogo,
  adriti1x,
  adriti2x,
  adriti3x,
  kyle1x,
  kyle2x,
  kyle3x,
  kara1x,
  kara2x,
  kara3x,
  wordpressAuthorizationConnect,
  gonzaloTorrerasLogo,
  hubSpotForStartupsLogo,
  lockScreenAnimation,
  emailAnimation,
  salesLeaderCalendar,
  salesMeetingsCalendar,
  salesMeetingsConfirmation,
  timeslotCalendar,
  connectLogo,
  connectMobileLogo,
  academyLogo,
  linkedInLogo,
  microsoftLogo,
  facebookLogo,
  appleLogo
}, illustrationUrls, {
  cmsFreeAnimation,
  cmsFreeMarketplace1x,
  cmsFreeMarketplace2x,
  cmsFreeMarketplace3x,
  hubspotIntegrations,
  hubspotIntegrationsAnimation,
  emailConfirmation,
  emailTracking,
  salesExtensionInstall,
  salesExtensionReview,
  checkSign,
  chatSpotLogo,
  chatSpotMobileLogo,
  welcomeImage,
  appleLogoWhite,
  linkedinLogoWhite,
  paypalLogo,
  wordpressLogo
});